import React from 'react';

import { Label } from 'recharts';

export const getPolarRadiusAxisLabel = (value, dy, angle) => (
  <Label value={value} dy={dy} angle={angle} fill='currentColor' />
);

export const getXAxisLabel = value => <Label value={value} position='bottom' fill='currentColor' />;

export const getYAxisLabel = (value, offset, dx) => (
  <Label
    className='graph-label'
    value={value}
    offset={offset}
    dx={dx}
    position='left'
    angle={270}
    fill='currentColor'
  />
);
